document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.multi-select-dropdown').forEach(function (dropdown) {
		var toggle = dropdown.querySelector('.dropdown-toggle');
		var dropdownListHolder = dropdown.querySelector('.dropdown-list-holder');
		var dropdownList = dropdown.querySelector('.dropdown-list');
		var checkboxes = dropdown.querySelectorAll('input[type="checkbox"]');
		var selectedItems = [];
		var defaultText = toggle.dataset.defaultText || 'Select';

		checkboxes.forEach(function (checkbox) {
			checkbox.addEventListener('change', function () {
				var labelText = checkbox.nextElementSibling.textContent;
				if (checkbox.checked) {
					if (!selectedItems.some(item => item.value === checkbox.value)) {
						selectedItems.push({ value: checkbox.value, label: labelText });
					}
				} else {
					selectedItems = selectedItems.filter(function (item) {
						return item.value !== checkbox.value;
					});
				}

				updateButtonText();
			});
		});

		function updateButtonText() {
			if (selectedItems.length > 0) {
				if (selectedItems.length > 1) {
					toggle.innerHTML = '<span class="selected">' + selectedItems.length + ' Selected </span>';
				} else {
					var selectedItemsHtml = selectedItems.map(function (item) {
						return '<span class="selected-item" data-value="' + item.value + '">' + item.label + '</span>';
					}).join(', ');
					toggle.innerHTML = '<span class="selected">' + selectedItemsHtml + '</span>';
				}
			} else {
				toggle.innerHTML = '<span class="selected">' + defaultText + '</span>';
				checkboxes.forEach(function (checkbox) {
					if (checkbox.value === 'all') {
						checkbox.checked = true;
					}
				});
			}
		}

		function showDropdownList() {
			dropdownListHolder.classList.remove('hide');
			dropdownList.setAttribute('aria-hidden', 'false');
			toggle.setAttribute('aria-expanded', 'true');
		}

		function hideDropdownList() {
			dropdownListHolder.classList.add('hide');
			dropdownList.setAttribute('aria-hidden', 'true');
			toggle.setAttribute('aria-expanded', 'false');
		}

		toggle.addEventListener('click', function () {
			if (dropdownListHolder.classList.contains('hide')) {
				showDropdownList();
				toggle.focus(); // Focus on the toggle element
			} else {
				hideDropdownList();
			}
		});

		toggle.addEventListener('keydown', function (e) {
			if (e.key === ' ' || e.key === 'Spacebar') {
				e.preventDefault();
				if (dropdownListHolder.classList.contains('hide')) {
					showDropdownList();
				} else {
					hideDropdownList();
				}
			}
		});

		document.addEventListener('click', function (e) {
			if (!dropdown.contains(e.target)) {
				if (!dropdownListHolder.classList.contains('hide')) {
					hideDropdownList();
					// toggle.focus(); // Focus on the toggle element
				}
			}
		});

		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape') {
				hideDropdownList();
				toggle.focus(); // Focus on the toggle element
			}
		});
	});
});
